import React, {useEffect, useState} from 'react';
import axios from "axios";
import {header} from "../../../../../../components/api/Header";
import {Dropdown} from "react-bootstrap";
import { getEnv } from "../../../../../../lib/env";
function Main(props) {
    const [season, setSeason] = useState('')
    const [year, setYear] = useState(new Date().getFullYear())
    const [ekinlar, setEkinlar] = useState([])
    const [selectedCropIds, setSelectedCropIds] = useState([])
    useEffect(()=>{
        const fetchCrops = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/district/sfrmain/ekinlar?season="+season, header())
                .catch(err=>{
                    console.log("Xato",err)
                })
            if(res){
                setEkinlar(res.data)
                const selectedC1 = localStorage.getItem('sfr-hm-'+season+'-ekinids')
                const selectedC2 = selectedC1?JSON.parse(selectedC1):[]
                let fcids = selectedC2.filter(eid => res.data.find(ekin => ekin.id == eid))
                setSelectedCropIds(fcids)
            }
        }
        if(season){
            fetchCrops()
        }
    },[season])
    const setEkin = (checked,id) => {
        let a = [];
        let ids = [...selectedCropIds];
        if(checked === false){
            a = ids.filter(c=>c!=id)
            setSelectedCropIds(a)
        }else {
            ids.push(id)
            setSelectedCropIds(ids)
        }
    }
    const correctCrops = async () => {
        const res = await axios.get(getEnv('REACT_APP_BASE_URL') + "/v1/district/sfrmain/ekinids?crops=" + selectedCropIds, header())
            .catch(e => {
                console.log("Xato", e)
            })
            if (res.data) {
                console.log(res)
                if(res.data[0]){
                    localStorage.setItem('sfr-hm-'+season+'-ekinids',JSON.stringify(res.data[0]))
                }
                if(res.data[1]){
                    localStorage.setItem('sfr-hm-'+season+'-ekinlar',JSON.stringify(res.data[1]))
                }
            }

    }
    const saveHandler = () => {

        localStorage.setItem('sfr-hm-season',season)
        localStorage.setItem('sfr-hm-year',year)
        correctCrops().then(()=>{
            window.location.href = "/sfr/gidromodul/new/insert"
        })
    }
    let fcids = []
    return (
        <div style={{paddingTop:"20vh", maxWidth:"300px"}} className="mx-auto">
            <div className="row">
                <div className="col-12">
                    <div className="form-group">
                        <p className="m-0">Sug'orish davrini tanlang</p>
                        <select className="form-select" onChange={e=>setSeason(e.target.value)} value={season}>
                            <option value="">--tanlanmagan--</option>
                            <option value="veg">Vegetatsiya</option>
                            <option value="noveg">Novegetatsiya</option>
                        </select>
                    </div>
                </div>
                <div className="col-12 my-4">
                    <div className="form-group">
                        <p className="m-0">Yilni kiriting</p>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Yil"
                            min={1990}
                            max={new Date().getFullYear()+1}
                            value={year}
                            onChange={e=>setYear(e.target.value)}/>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <p className="m-0">Ekin turini tanlang</p>
                        <Dropdown>
                            <Dropdown.Toggle variant="outline-secondary" className="w-100 d-flex justify-content-between align-items-center" id="dropdown-basic">
                                {selectedCropIds.length?selectedCropIds.length:0} ta ekin tanlandi
                            </Dropdown.Toggle>
                            <Dropdown.Menu as="ul" className="w-100" style={{maxHeight:"300px",overflow:"scroll"}}>
                                {
                                    ekinlar.length > 0
                                        ? ekinlar.map((ekin,index)=>{
                                            return(
                                                <Dropdown.Item key={index} as="li" onClick={e=>e.stopPropagation()}>
                                                    <label htmlFor={'item'+index} className="w-100">
                                                        <input
                                                            type="checkbox"
                                                            id={'item'+index}
                                                            onChange={e=>setEkin(e.target.checked,ekin.id)}
                                                            checked={selectedCropIds.includes(ekin.id)?true:false}
                                                        /> &nbsp;&nbsp;
                                                        {ekin.nomi}
                                                    </label>
                                                </Dropdown.Item>
                                            )
                                        }) :null
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                <div className="col-12 mt-4 text-end">
                    <button disabled={(year!=''&&season&&selectedCropIds.length)?false:true} className="btn btn-primary" onClick={()=>saveHandler()}>Davom etish</button>
                </div>
            </div>
        </div>
    );
}

export default Main;